import {FC} from 'react'

import {theme} from '@/theme/theme'
import {QuestionsAndAnswersAuthor} from '@/utils/questions-and-answers/types'

import {ContentWithInnerHTML} from '../common/content/ContentWithInnerHTML'
import {Author} from '../help-center/Author'

type QuestionsAndAnswersAnswerProps = {
  answer: string
  author: QuestionsAndAnswersAuthor
  date?: string
}

export const QuestionsAndAnswersAnswer: FC<QuestionsAndAnswersAnswerProps> = ({
  answer,
  author,
  date,
}) => {
  const {name, role, photo, slug} = author

  return (
    <>
      <Author
        name={name}
        role={role}
        photoSrc={`/images/team/${photo}`}
        photoAlt={`Photo of ${name}`}
        slug={slug}
        date={date}
      />
      <div className="answer">
        <ContentWithInnerHTML content={answer} />
      </div>

      <style jsx>{`
        .answer {
          margin-top: ${theme.spacing[5]};
        }
      `}</style>
    </>
  )
}
